import React, { useEffect, useState } from "react";
import "./videoUploading.scss";
import { Box, LinearProgress, Paper, Typography } from "@mui/material";
import cancelUpload from "../../../../assets/images/upload/cancelUploadIcon.svg";
import UploadAnimation from "./UploadAnimation";
import {
  fileUploadSuccessHandler,
  userInfoFetch,
} from "../../../../utlis/commonFunction";
import { useDispatch, useSelector } from "react-redux";
import { BlockBlobClient } from "@azure/storage-blob";
import { setVideoFile } from "../../../../state/actions/videoUploadAction";
import { pageLocale } from "../../../../utlis/locale";
import { getAssetToken } from "../../../../services/v5Api";

const VideoUploading = ({ statusVal, styleChange }) => {
  const moduleInfo = JSON.parse(sessionStorage.getItem("fromUpload") || "");
  // const romTabIndex = parseInt(sessionStorage.getItem("romTabIndex"));
  const file = useSelector((state) => state.videoSaved.pickedVideofile);
  const { video_uploading, alert, cancel_upload_btn } =
    pageLocale("videoUpload");
  const dispatch = useDispatch();
  const [uploadValue, setUploadValue] = useState(0);
  const [abortController, setAbortController] = useState(null);
  const urlPath = window.location.pathname;
  const moduleFileName = () => {
    if (
      moduleInfo?.moduleId === 4 ||
      moduleInfo?.moduleId === 1 ||
      moduleInfo?.moduleId === 2
    ) {
      return "test_video.mp4";
    }
    if (moduleInfo?.moduleId === 5) {
      if (urlPath === "/rom-left-flexion") {
        return "100/100.mp4";
      }
      if (urlPath === "/rom-left-extension") {
        return "200/200.mp4";
      }
      if (urlPath === "/rom-right-flexion") {
        return "300/300.mp4";
      }
      if (urlPath === "/rom-right-extension") {
        return "400/400.mp4";
      }
    }
  };

  const subModuleIdHandler = () => {
    if (moduleInfo?.moduleId === 5) {
      if (urlPath === "/rom-left-flexion") {
        return [100];
      }
      if (urlPath === "/rom-left-extension") {
        return [200];
      }
      if (urlPath === "/rom-right-flexion") {
        return [300];
      }
      if (urlPath === "/rom-right-extension") {
        return [400];
      }
    } else return null;
  };

  const acllfile = async () => {
    try {
      const controller = new AbortController();
      setAbortController(controller);

      const userId = userInfoFetch()?.id;
      const fileName = moduleFileName();

      // Get SAS Token (which now returns the full upload URL)
      const tokenResponse = await getAssetToken(
        fileName,
        moduleInfo?.moduleId,
        userId,
      );

      // Extract uploadUrl and blobPath from response
      const uploadUrl = tokenResponse?.data?.uploadUrl;
      const blobPath = tokenResponse?.data?.blobPath;

      if (!uploadUrl) {
        throw new Error("Failed to retrieve upload URL");
      }

      // Use the provided uploadUrl directly
      const blockBlobClient = new BlockBlobClient(uploadUrl);

      await blockBlobClient.uploadBrowserData(file, {
        blockSize: 4 * 1024 * 1024, // 4MB block size
        concurrency: 5,
        onProgress: (ev) => {
          if (ev.loadedBytes && file.size) {
            setUploadValue(Math.round((ev.loadedBytes / file.size) * 75));
          }
        },
        abortSignal: controller.signal,
        blobHTTPHeaders: { blobContentType: file.type },
      });
      const res = await fileUploadSuccessHandler(
        userId,
        moduleInfo?.moduleId,
        blobPath,
        subModuleIdHandler(),
      );

      setUploadValue(100);
      dispatch(setVideoFile(null));
      sessionStorage.setItem("romReportId", res?.data?.data?.reportId);
      statusVal(3);
    } catch (error) {
      if (
        error.name === "AbortError" ||
        error.code === "REQUEST_ABORTED_ERROR"
      ) {
        console.log("Upload cancelled");
        // Handle cancellation
      } else {
        console.error("Upload failed", error);
        dispatch(setVideoFile(null));
        statusVal(4);
      }
    }
  };

  useEffect(() => {
    if (file) {
      acllfile();
    }
  }, []);

  const cancelUploadHandler = () => {
    if (abortController) {
      abortController.abort();
      statusVal(2);
    }
  };

  return (
    <div className="video-uploading-main-wrapper">
      {!styleChange && (
        <Typography className="title">{moduleInfo?.moduleName}</Typography>
      )}
      <Paper elevation={3} className={`info `}>
        <UploadAnimation />
        <Typography className="upload-text">{video_uploading}</Typography>
        <Box sx={{ width: "60%" }} className="bar-wrapper">
          <LinearProgress
            className="linear-bar"
            variant="determinate"
            value={uploadValue}
            sx={{
              "& .MuiLinearProgress-bar": {
                backgroundColor:
                  "linear-gradient(180deg, #F4C745 0%, #D19F0D 100%)",
              },
              backgroundColor:
                "linear-gradient(180deg, #F4C745 0%, #D19F0D 100%)",
            }}
          />
          <Typography className="upload-value">{uploadValue}%</Typography>
        </Box>
        <div className="cancel-btn-wrapper">
          <Typography className="cancel-info">{alert}</Typography>
          {uploadValue < 70 && (
            <div
              className="upload-cancel-btn-wrapper"
              onClick={() => cancelUploadHandler()}
            >
              <img src={cancelUpload} alt="cancel" />
              <Typography className="cancel-btn-text">
                {cancel_upload_btn}
              </Typography>
            </div>
          )}
        </div>
      </Paper>
    </div>
  );
};

export default VideoUploading;
